import React from "react";
import FormatedDate from "./FormatedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo body ">
      <div className="row  align-items-center">
        <div className="col-3 weatherIcon">
          <WeatherIcon
            code={props.data.icon}
            alt={props.data.description}
            size={130}
          />
        </div>
        <div className="col-5">
          <ul>
            <li>
              <h2 className="searchedLocation text-capitalize">
                {props.data.city}
              </h2>
            </li>
            <li>
              <FormatedDate date={props.data.date} />
            </li>

            <li>
              <WeatherTemperature celsius={props.data.temperature} />
            </li>
          </ul>
        </div>
        <div className="col-4">
          <ul>
            <li className="text-capitalize description">
              {props.data.description}
            </li>
            <li className="description">Humidity: {props.data.humidity}%</li>
            <li className="description">
              Wind: {Math.round(props.data.wind)}km/h
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
